exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating-container{display:flex;align-items:center;flex-wrap:wrap;width:fit-content}.rating-item{cursor:pointer}.rating-container.disabled .rating-item{cursor:default}.star-description{margin-left:1em;min-width:130px;padding:.5em;text-align:center;font-weight:700;color:#fff}.active{color:#f3d23e}.star-poor{background:#bababa}.star-belowAverage{background:#f5c357}.star-average{background:#ffac5a}.star-good{background:#c1d759}.star-excellent{background:#48964d}.rating-result{margin-left:.5em;font-family:Segoe UI,Tahoma,Geneva,Verdana,sans-serif}.star-hover{color:#f3d23e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-054f9d05","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/complex-input-elements/StarRating.vue
// module id = 530
// module chunks = 38